import React from 'react';
import {FacebookOutlined, LinkedinOutlined, TwitterOutlined, YoutubeOutlined} from '@ant-design/icons';

export const SocialMedia:React.FunctionComponent = (_props) => {
    return (
        <div style={{ textAlign: 'center', marginTop: 20 }}>
            <a href="https://www.facebook.com/DiazarControl/" target="_blank" rel="noopener noreferrer">
                <FacebookOutlined style={{ fontSize: 24, margin: '0 10px', color: '#1877F2' }} />
            </a>
            <a href="https://twitter.com/diazarcontrol" target="_blank" rel="noopener noreferrer">
                <TwitterOutlined style={{ fontSize: 24, margin: '0 10px', color: '#1DA1F2' }} />
            </a>
            <a href="https://www.youtube.com/user/DiazarNoticias" target="_blank" rel="noopener noreferrer">
                <YoutubeOutlined style={{ fontSize: 24, margin: '0 10px', color: '#FF0000' }} />
            </a>
            <a href="https://www.linkedin.com/in/diazar-control-5068323b" target="_blank" rel="noopener noreferrer">
                <LinkedinOutlined style={{ fontSize: 24, margin: '0 10px', color: '#0A66C2' }} />
            </a>
        </div>
    );
};
